export default "/images/vendor/flag-icon-css/flags/4x3/gw.svg?442e700de324c517fda86121705acd21";